<template>
  <div class="wrapper">
	   <headerTag />
       <div class="detailCon1">
		  <img src="../../assets/images/detail/jwtz.png" alt=""  />
	   </div>
	   <div class="detailCon1-div1 clear">
	   			  <p>
	   				  <span>ODI境外投资</span>
	   				  <span v-if="productPrice=='my'">
	   				  		面议
	   				  </span>
	   				  <span v-else>
	   				  		￥{{productPrice}}
	   				  </span>
	   			  </p>
	   			  <p>        
	   				高效办理境外业务，外企服务领跑者。
	   			  </p>
	    </div>
	 
	  <div class="detailCon detailCon3">
	  	  <p class="detailCon2-tips" style="margin-top: 0;">
	  		 服务简介
	  	   </p>
		   
		   <p>
				注册在中华人民共和国境内的企业，直接或间接获得境外公司的所有权，控制权、经营管理权等，需要遵守《企业境外投资管理办法》。 
				<br>用户只需要依据要求提供投资主体信息、项目概况，我们将代为撰写所有申请文件，并负责与审批部门进行沟通。                     
			</p>
	   </div>
	  <div class="detailCon detailCon4">
	   	  <p class="detailCon2-tips" style="margin-top: 0;">
	   		 服务流程
	   	   </p>
	   	   <p>
			   <span>
				   <img src="../../assets/images/detail/liucheng1.png" alt="" />
				   <i>咨询下单</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng2.png" alt="" />
			   		<i>提交材料</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng3.png" alt="" />
			   		<i>业务办理</i>
			   </span>
			   <span>
			   		<img src="../../assets/images/detail/liucheng4.png" alt="" />
			   		<i>售后服务</i>
			   </span>
		   </p>
	    </div>
	  <div class="detailCon detailCon5">
			  <p class="detailCon2-tips" style="margin-top: 0;">
				 所需材料
			   </p>
			  <div>
				  <p><i></i><span>境外投资备案表</span></p>
				  <p><i></i><span>公司营业执照复印件</span></p>
				  <p><i></i><span>其他所需补充材料</span></p>
			  </div>
	  </div>
		 
		 <div class="detailBottom-box">
			<div class="detailBottom">
				<p @click="runQq()">
					<i>
						<img src="../../assets/images/detail/QQ.png" alt="" style="height: 1.23rem;" />
					</i>
					
					<span>QQ联系</span>
				</p>
				<p @click="runWx()">
					<i>
						<img src="../../assets/images/detail/weixin.png" alt="" style="height: 1rem;" />
					</i>
					<span>微信联系</span>
				</p>
				<p>
					<a :href="'tel:'+phoneNum">
						<i>
							<img src="../../assets/images/detail/phone.png" alt="" style="height: 0.92rem;" />
						</i>
						<span>电话联系</span>
					</a>
				</p>
				<button @click="buyThis" v-bind:disable="dis" :class="{'cur': dis == true}">{{buyBtn}}</button>
			</div>
		 </div>
		
		
		<van-popup v-model="wxShow" class="popDiv erDiv">
				<p>
					<span>扫码咨询</span>
					<img src="../../assets/images/detail/close.png" class="closeImg" @click="wxShow=false" />
				</p>
				<img :src="wxPic" class="erImg" />
				<p class="wxTitle">
					<i></i>
					<span>微信号</span>
					<i></i>
				</p>
				<p class="erNum" id="copyValue">{{wxNum}}</p>
				<p class="copyBtn">
					<button @click="copy" data-agl-cvt="32" id="copyTxt" data-clipboard-action="copy" data-clipboard-target="#copyValue">复制</button>
				</p>
				<p class="wxTips">扫一扫或复制微信号，添加好友咨询~</p>
		</van-popup>
   </div>
</template>

<script>
  import "../../assets/css/detail.scss"
  import headerTag from '@/components/headerTag/headerTag.vue'
  import { getProductDetail,getProv,getCity,getCustomerInfo,openConsult,nowBuyProduct } from '../../assets/js/common.js' 
  import { myMixin } from '../../mixins' 
  import { Popup,Picker } from 'vant'
  import Clipboard from 'clipboard'
 
  export default {
    name: 'productJwtz',
	mixins:[myMixin],
	props:{
		
	},
	data(){
		return {
			bussFlag:29,
			isShow:0,
			wxShow:false,//微信弹框
			dis:true, //立即购买按钮的disable
			buyBtn:'请咨询客服',
		}
	},
	components: {
       headerTag,
	   [Popup.name]:Popup,
	   [Picker.name]:Picker ,
     },
	 methods:{
		 buyThis(){
			let _this=this;
		 	if(this.pid == null || this.pid == "" ){
			  	_this.$message.error({message: "暂无产品，请咨询客服"});
			  	return;
		    }
		    _this.dis=true; // 不可点击
			nowBuyProduct(this.pid,function(data){
				_this.dis=false;
				if(data.code == 1000){
					//成功
					window.location.href='/order/paySure/'+data.obj;
				}else if(data.code == 1110){
					//未登录
					let currPath=window.location.href;
					window.location.href='/login?targetUrl='+currPath;
				}else{
					_this.$message.error({message: errorback});
				}
			},(errorback)=>{
				_this.dis=false;
				_this.$message.error({message: errorback});
			})
			
		 }, 
		
		runQq(){//QQ联系
			openConsult(this.qqNum);
		},
		runWx(){//微信联系
			if(this.wxNum==null){
				this.wxShow=false;
				this.$message('该业务员暂无微信');
			}else{
				this.wxShow=true;
			}
		},
		copy(){
			var clipboard = new Clipboard('#copyTxt', {
			    text: function () {
			        //return $('#copyValue').text();
			    }
			});
					
			clipboard.on('success', e => {  
				this.$message.success({message: '已复制成功，快去微信添加好友吧~~',customClass:'mzindex'});
				// 释放内存  
				clipboard.destroy()  
			})  
			clipboard.on('error', e => {  
				  // 不支持复制 
				   this.$message.error({message: '抱歉哦，复制失败请手动复制微信号~~',customClass:'mzindex'});
				  // 释放内存  
				  clipboard.destroy()  
			})  
			       
		},
	 },
	 created() {
		 let _this = this;
		getProductDetail(29,this.$route.params.pid,function(data){ //产品信息
			if(data.obj == "" || data.obj == null){
				_this.productPrice='my';
				_this.dis=true;
				_this.buyBtn="请咨询客服";
			}else{
				_this.productPrice=data.obj.price;
				_this.pid = data.obj.pid;
			}
		},(errorback)=>{
			_this.$message.error({message: errorback});
		})
		
		getCustomerInfo(function(data){//业务员信息
			_this.qqNum=data.qq;
			_this.wxNum=data.wx;
			_this.phoneNum=data.phone;
			_this.wxPic=_this.rootUrl+data.wxPic;
		},()=>{
			_this.$message.error({message: '网络异常，请稍后重试'});
		})
		
	 },
   }
</script>